import {
  DiaprofilTopic,
  manualItemTypes,
  ISupportFor,
  Score,
  topicNames
} from "./types";
import { TranslateService } from "@ngx-translate/core";
import { DashboardService } from "../services/dashboard.service";

export function manualItemFactory(
  config: IManualItem,
  translate: TranslateService,
  dashboard: DashboardService
) {
  return new ManualItem(config, translate, dashboard);
}

export interface IManualItem {
  id: string;
  sourceUrl: string;
  title: string;
  itemType: manualItemTypes;
  questionnaireItemId: string;
  consultationTopicId: string;
  consultationTopicIdVersion2: string;
  patientWishId: string;
  scoreId: Score;
  dashboardAreaId: topicNames;
  manualText: string;
  relevantTopics: DiaprofilTopic[];
  defaultTopics: DiaprofilTopic[];
  created: string;
  modified: string;
}

export class ManualItem implements IManualItem {
  id: string;
  sourceUrl: string;
  title: string;
  itemType: manualItemTypes;
  questionnaireItemId: string;
  consultationTopicId: string;
  consultationTopicIdVersion2: string;
  patientWishId: string;
  scoreId: Score;
  dashboardAreaId: topicNames;
  manualText: string;
  relevantTopics: DiaprofilTopic[];
  defaultTopics: DiaprofilTopic[];
  created: string;
  modified: string;
  constructor(
    private config: IManualItem,
    public translate: TranslateService,
    public dashboard: DashboardService
  ) {
    this.id = this.config.id;
    this.sourceUrl = this.config.sourceUrl;
    this.title = this.config.title;
    this.itemType = this.config.itemType;
    this.questionnaireItemId = this.config.questionnaireItemId;
    this.consultationTopicId = this.config.consultationTopicId;
    this.consultationTopicIdVersion2 = this.config.consultationTopicIdVersion2;
    this.patientWishId = this.config.patientWishId;
    this.scoreId = this.config.scoreId;
    this.dashboardAreaId = this.config.dashboardAreaId;
    this.manualText = this.config.manualText;
    this.relevantTopics = this.config.relevantTopics;
    this.defaultTopics = this.config.defaultTopics;
    this.created = this.config.created;
    this.modified = this.config.modified;
  }

  isRelevant(props: { supportFor: ISupportFor }): boolean {
    const itemType = this.itemType;
    let condition: boolean;
    const hasIntersection = (a: string[], b: string[]) => {
      if (a === null || b === null) {
        return false;
      }
      const setA = new Set(a);
      const setB = new Set(b);
      return [...setA].filter(id => setB.has(id)).length > 0;
    };
    switch (itemType) {
      case "CONSULTATION_TOPIC": {
        condition = hasIntersection(
          [this.consultationTopicIdVersion2],
          props.supportFor.consultationTopics.map(option => option.code)
        );
        break;
      }
      case "DIAPROFIL_PRO_ITEM": {
        condition = hasIntersection(
          [this.questionnaireItemId],
          props.supportFor.proItems.map(item => item.config.name)
        );
        break;
      }
      case "SCORE": {
        condition = hasIntersection([this.scoreId], props.supportFor.scoreIds);
        break;
      }
      case "DASHBOARD_AREA": {
        condition = hasIntersection(
          [this.dashboardAreaId],
          props.supportFor.dashboardAreaIds
        );
        break;
      }
      default: {
        condition = false;
        break;
      }
    }
    return condition;
  }

  get displayTitle(): string {
    const itemType = this.itemType;
    let translation = "",
      value = null;
    switch (itemType) {
      case "CONSULTATION_TOPIC": {
        value = this.consultationTopicIdVersion2;
        if (value !== null) {
          const consultationTopics = this.dashboard.getConsultationTopicOptions();
          const code = consultationTopics.find(topic => topic.code === value);
          translation = code.display;
        }
        break;
      }
      case "DIAPROFIL_PRO_ITEM": {
        value = this.questionnaireItemId;
        if (value !== null) {
          const questionnaireItems = this.dashboard.widgets;
          const widget = questionnaireItems.find(item => item.name === value);
          if (!widget) {
            return null;
          }
          translation = `${widget.prefix} ${widget.label}`;
        }
        break;
      }
      case "SCORE": {
        value = this.scoreId;
        translation = value; // TODO: Replace this with fuller code later
        break;
      }
      case "DASHBOARD_AREA": {
        value = this.dashboardAreaId;
        translation = this.translate.instant(`VBS_PRO_DIA_TOPIC.${value}`); // TODO: Replace this with fuller code later
        break;
      }
      default: {
        translation = null;
        break;
      }
    }
    return translation;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/manual-item.ts